import type { PropsWithChildren } from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';

const timelineListSx: SxProps<Theme> = theme => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '22px',
  listStyle: 'none',
  margin: '0 0 20px',
  padding: 0,
  '& blockquote': {
    m: '0 0 20px',
    p: '11px 25px 11px 17px',
    color: 'text.secondary',
    fontStyle: 'italic',
    backgroundColor: 'background.default',
    borderLeft: '6px solid',
    borderLeftColor: 'border.default',
    transform: 'translateY(10px)',
  },
  '& .timeline__entry .card': {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    color: 'text.primary',
    wordWrap: 'break-word',
    backgroundColor: 'common.white',
    backgroundClip: 'initial',
    border: 0,
    borderRadius: '0.25rem',
    boxShadow: `0 1px 2px ${theme.palette.common.shadowDefault}, 0 2px 4px 2px ${theme.palette.common.softBorder}`,
    '&:not(.border-success)': {
      borderLeft: '4px solid',
      borderLeftColor: 'border.medium',
    },
    '&.border-success': {
      border: '1px solid !important',
      borderColor: 'success.main !important',
      '& .card-body': { pb: '20px' },
      '& .MuiButtonBase-root': { fontSize: '14px' },
    },
  },
  '& .timeline__entry.feedback .card:not(.border-success)': { borderLeftColor: 'timeline.feedback' },
  '& .timeline__entry.note .card:not(.border-success)': { borderLeftColor: 'timeline.note' },
  '& .timeline__entry.strategy .card:not(.border-success)': { borderLeftColor: 'timeline.strategy' },
  '& .timeline__entry.candidate_sender .card:not(.border-success), & .timeline__entry.email .card:not(.border-success)':
    { borderLeftColor: 'timeline.email' },
  '& .timeline__entry.call .card:not(.border-success)': { borderLeftColor: 'timeline.call' },
  '& .timeline__entry.meeting .card:not(.border-success)': { borderLeftColor: 'timeline.meeting' },
  '& .timeline__entry.demo .card:not(.border-success)': { borderLeftColor: 'timeline.demo' },
  '& .timeline__entry.planning .card:not(.border-success)': { borderLeftColor: 'timeline.planning' },
  '& .timeline__entry.skipped .card:not(.border-success)': { borderLeftColor: 'timeline.skipped' },
  '& .timeline__entry.syberry_sender .card:not(.border-success), & .timeline__entry.resume .card:not(.border-success)':
    { borderLeftColor: 'border.default' },
});

const TimelineList = ({ children }: PropsWithChildren) => (
  <Box component="ul" className="timeline" sx={timelineListSx}>
    {children}
  </Box>
);

export default TimelineList;
